import { useState } from 'react';

export const useForceUpdate = () => {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((prev) => ++prev); // update the state to force render
};
